import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyAdminDebitCredit } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./AdminDebitCreditPage.css";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const AdminDebitCreditPage = () => {
  const [transactions] = useState(dummyAdminDebitCredit);
  const [search, setSearch] = useState("");

  const filtered = transactions.filter(
    (t) =>
      t.user_id?.toLowerCase().includes(search.toLowerCase()) ||
      t.emailId?.toLowerCase().includes(search.toLowerCase()) ||
      t.description?.toLowerCase().includes(search.toLowerCase()) ||
      t.transaction_type?.toLowerCase().includes(search.toLowerCase()) ||
      t.from_admin?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Admin Debit Credit</span>
          </p>
          <h1 className="dashboard-hero__title">Admin Debit Credit</h1>
          <p className="dashboard-hero__subtitle">
            Admin debit and credit transactions
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-exchange-alt" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="admintrans-section">
          <div className="admintrans-section__header">
            <div className="admintrans-section__title-wrap">
              <span className="admintrans-section__icon">
                <i className="fas fa-wallet" />
              </span>
              <h2 className="admintrans-section__title">Admin Debit / Credit Transactions</h2>
            </div>
            <div className="admintrans-section__stats">
              <span className="admintrans-stat">
                <strong>{transactions.length}</strong> Transactions
              </span>
              <span className="admintrans-stat">
                <strong>{transactions.filter((t) => (t.transaction_type || "").toUpperCase() === "CREDIT").length}</strong> Credit
              </span>
              <span className="admintrans-stat">
                <strong>{transactions.filter((t) => (t.transaction_type || "").toUpperCase() === "DEBIT").length}</strong> Debit
              </span>
            </div>
          </div>
          <div className="admintrans-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by user ID, email, description, type or admin..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="admintrans-search-input"
            />
          </div>
          <div className="admintrans-table-wrap">
            <table className="admintrans-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Created</th>
                  <th>User ID</th>
                  <th>Email</th>
                  <th>Amount</th>
                  <th>Currency</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>From Admin</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row) => (
                  <tr key={row.index}>
                    <td>{row.index + 1}</td>
                    <td>{formatDate(row.createdAt)}</td>
                    <td><span className="admintrans-mono">{row.user_id}</span></td>
                    <td>{row.emailId}</td>
                    <td>{typeof row.amount === "number" ? row.amount.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.amount}</td>
                    <td><strong>{row.short_name}</strong></td>
                    <td>{row.description}</td>
                    <td>
                      <span className={`admintrans-type admintrans-type--${(row.transaction_type || "").toLowerCase()}`}>
                        {row.transaction_type}
                      </span>
                    </td>
                    <td><span className="admintrans-admin">{row.from_admin}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtered.length === 0 && (
            <p className="admintrans-empty">No transactions match your search.</p>
          )}
        </section>
      </div>
    </main>
  );
};

export default AdminDebitCreditPage;
